import { useMutation, useQueryClient } from '@tanstack/react-query';

import { RestApiError } from 'services/api/restful/errors';
import {
  addFavourite,
  getGetFavouriteQueryKey,
  getListFavouritesQueryKey,
} from 'services/api/restful/generated/accounts/accounts';
import type { FavouriteType } from 'services/api/restful/generated/nofomoRestApi.schemas';

type AddFavouriteVariables = { type: FavouriteType; value: string };

export const useAddFavourite = () => {
  const queryClient = useQueryClient();

  const mutation = useMutation<void, RestApiError, AddFavouriteVariables>({
    mutationFn: async ({ type, value }) => {
      await addFavourite({ type, value });
    },
    onSuccess: async (_data, { type, value }) => {
      await queryClient.invalidateQueries({
        queryKey: getListFavouritesQueryKey(),
      });
      await queryClient.invalidateQueries({
        queryKey: getGetFavouriteQueryKey(type, value),
      });
    },
  });

  return {
    addFavourite: (
      type: FavouriteType,
      value: string,
      options?: { onError?: () => void },
    ) => mutation.mutate({ type, value }, options),
    isLoading: mutation.isPending && !mutation.isPaused,
    error: mutation.error,
  };
};
